export default "__VITE_PUBLIC_ASSET__6992c737__"